module.exports = __webpack_public_path__ + "static/media/person-three-circles.3a69c3a1.svg";